import {THEME} from '../globals/typings';
import {getCountryCodeFromLocale} from '../utils/utils';

interface State {
  locale: string;
  theme: THEME;
  qa: boolean;
}

class MccTranslationService {
  private translations$: Promise<any>;
  private translations: any;
  private state: State;

  async load(locale: string, theme: THEME, qa: boolean = false) {
    if (!this.translations$ || this.state.locale !== locale || this.state.theme !== theme || this.state.qa !== qa) {
      console.debug('Loading translations from CC... ');
      this.state = {locale: locale, theme: theme, qa: qa};
      this.translations$ = fetch(`https://${qa ? 'qa-' : ''}cc.porscheinformatik.com/cc-${getCountryCodeFromLocale(locale).toLowerCase()}/${locale}_${theme}/mcc-messages`)
        .then(response => response.json())
        .then(translations => {
          this.translations = translations;
          return this.translations;
        });
    }
    return this.translations$;
  }

  get(key: string) {
    if (!(key in this.translations)) {
      console.warn(`Translation for '${key}' not found.`)
      return key;
    }
    if (this.translations[key] === undefined || this.translations[key] === null) {
      return '';
    }
    return this.translations[key];
  }
}

export const TranslationService = new MccTranslationService();
